import React from 'react'

import { Text } from '@plurall/elo-beta'

import styles from './Menu.module.scss'
import { useMenu } from './useMenu'

const Menu = () => {
  const { menuData } = useMenu()

  return (
    <ul className={styles.menu}>
      {menuData.map(({ link_url: url, name, target }, index) => (
        <li
          data-test-id={`menu-item-${index + 1}`}
          key={name}
          className={styles['menu-item']}
          style={{
            order: index + 1,
          }}
        >
          <Text
            dataTestId={`menu-item-${index + 1}-link`}
            size='t3'
            element='a'
            href={url}
            target={target}
          >
            {name}
          </Text>
        </li>
      ))}
    </ul>
  )
}

export default Menu
